/* eslint-disable no-param-reassign */
angular
  .module('resyApp')
  .controller('DownloadCtrl', DownloadCtrl);

function DownloadCtrl($location, $scope, $window) {
  const ua = $window.navigator.userAgent;
  const params = $location.search();
  let GAParamsString;
  let redirectUrl;

  function getGAParams() {
    const GAParams = [];
    const GARegex = /^utm_/;
    const keys = Object.keys(params);
    keys.forEach(
      (paramName) => {
        if (paramName.match(GARegex)) {
          GAParams.push(`${paramName}=${encodeURIComponent(params[paramName])}`);
        }
      }
    );
    return GAParams.join('&');
  }

  if (ua.indexOf('iPhone') >= 0 || ua.indexOf('iPad') >= 0) {
    redirectUrl = 'https://itunes.apple.com/app/apple-store/id866163372?pt=86835890&mt=8';
    if (typeof params.ct !== 'undefined') {
      redirectUrl += `&ct=${encodeURIComponent(params.ct)}`;
    }

    $window.location = redirectUrl;
  } else if (ua.indexOf('Android') >= 0) {
    GAParamsString = getGAParams();

    redirectUrl = 'https://play.google.com/store/apps/details?id=com.resy.android';
    if (GAParamsString.length > 0) {
      redirectUrl += `&referrer=${encodeURIComponent(GAParamsString)}`;
    }

    $window.location = redirectUrl;
  } else {
    $location.url('/');
  }
}

export default () => {};
